// extracted by mini-css-extract-plugin
export default {"block":"_404_block__KI6oC","error":"_404_error__SvDPG","code":"_404_code__km-f5","line":"_404_line__-3lxy"};